import React from "react";
import { normalizeImageUrl } from "@/lib/imageUrl";

// Effective-logo hierarchy renderer.
// Pass the already-resolved src (Team logo -> Org logo). When empty, a branded
// CBR placeholder is shown so logo areas never look broken or unfinished.
// Use variant="dark" on navy/dark backgrounds so the placeholder stays visible.
export default function EntityLogo({
  src,
  alt = "",
  size = "w-full h-full",
  rounded = "rounded-sm",
  textSize = "text-[11px]",
  className = "",
  imgClass = "w-full h-full object-contain",
  variant = "light",
}) {
  const base = `${size} ${rounded} overflow-hidden grid place-items-center shrink-0 ${className}`;
  if (src) {
    return (
      <div className={`${base} bg-white border border-slate-100`}>
        <img src={normalizeImageUrl(src)} alt={alt} className={imgClass} loading="lazy" />
      </div>
    );
  }
  const placeholderBg = variant === "dark" ? "bg-white/10 border border-white/15" : "bg-[#0A192F]";
  return (
    <div className={`${base} ${placeholderBg}`} data-testid="entity-logo-placeholder">
      <span className={`font-display text-white/70 tracking-tighter leading-none ${textSize}`}>CBR</span>
    </div>
  );
}
